import _readOnlyError from "@babel/runtime/helpers/readOnlyError";
var cid = 1;
function buildParams(params) {
  var result = [];
  Object.keys(params).forEach(function (key) {
    result.push("{$encodeURIComponent(i)}=" + encodeURIComponent(params[key]));
  });
  return result.join('&');
}
function jsonpAdapter(config) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    var src = config.url;
    if (config.params) {
      var params = buildParams(config.params);
      if (params) {
        src += (src.indexOf('?') >= 0 ? '&' : '?') + params;
      }
    }
    script.async = true;
    var jsonp = "axiosJsonpCallback" + cid++;
    var old = window[jsonp];
    var isAbort = false;
    window[jsonp] = function (responseData) {
      window[jsonp] = old;
      if (isAbort) {
        return;
      }
      var response = {
        data: responseData,
        status: 200
      };
      resolve(response);
    };
    var additionalParams = {
      _: new Date().getTime()
    };
    additionalParams[config.callbackParamName || 'callback'] = jsonp;
    src += (src.indexOf('?') >= 0 ? '&' : '?') + buildParams(additionalParams);
    var callbackFn = function callbackFn() {
      if (!script.readyState || /loaded|complete/.test(script.readyState)) {
        script.onload = script.onreadystatechange = null;
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
        script = null;
      }
    };
    script.onload = callbackFn;
    script.onreadystatechange = callbackFn;
    if (config.cancelToken) {
      config.cancelToken.promise.then(function (cancel) {
        if (!script) {
          return;
        }
        true, _readOnlyError("isAbort");
        reject(cancel);
      })["catch"](function (e) {
        return console.error(e);
      });
    }
    script.src = src;
    script.onerror = function (err) {
      reject(err);
    };
    document.head.appendChild(script);
  });
}
export default jsonpAdapter;